import { call, put, takeEvery } from 'redux-saga/effects';
import { ConfigPODTypes } from './actionTypes';
import * as url from '../../helpers/url_helper';
import { getConfigPODSuccess, getConfigPODFail, saveConfigPODSuccess, saveConfigPODFail } from './actions';
import Swal from 'sweetalert2';

export const fetchConfigPOD = async (data: any) => {
    const { OperationType } = data;
    const path = url.API_URL;
    let user;
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }
    console.log(user);
    const query = `query{
        GetConfigReportPOD(
            userId: ${user.id}, 
            OperationType: "${OperationType}"
        ) {
            success
            message
            data {
                clientId
                OperationType
                ShipmentType
                ShowLogo
                ShowPODtext
                Signature_Required
                Consignee_DisplayText
                Consignee_Visible
                ReleasedTo_DisplayText
                ReleasedTo_Visible
                DriverName_DisplayText
                DriverName_Visible
                ArrayBody {
                    Property
                    DisplayText
                    Visible
                }
                ArrayTable{
                    Property
                    DisplayText
                    Visible
                }
                Footer
            }
        }
    }
    `;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    const accessResponse = response.data.GetConfigReportPOD.data;
    console.log(accessResponse, 'sagas get config POD')
    return accessResponse ?? {};
};

function* getConfigPODSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchConfigPOD, data.payload);
        yield put(getConfigPODSuccess(response));
    } catch (error) {
        yield put(getConfigPODFail(error));
    }
}
export const fetchSaveConfigPOD = async (data: any) => {
    console.log('saveConfigPOD', data);
    const path = url.API_URL;
    let user;
    const getAuthUser = localStorage.getItem('authUser');
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const transformedArrayBodyString = data.ArrayBody.map((item: any) => `
  {
    Property: "${item.Property}",
    DisplayText: "${item.DisplayText}",
    Visible: ${item.Visible}
  }
`).join(',');

    const transformedArrayTableString = data.ArrayTable.map((item: any) => `
  {
    Property: "${item.Property}",
    DisplayText: "${item.DisplayText}",
    Visible: ${item.Visible}
  }
`).join(',');

    const arrayBodyString = data.ArrayBody.length > 0 ? `
  ArrayBody: [${transformedArrayBodyString}]
` : '';

    const arrayTableString = data.ArrayTable.length > 0 ? `
  ArrayTable: [${transformedArrayTableString}]
` : '';

    const query = `mutation {
        SaveConfigReportPOD(ConfigReport: {
            userId: ${user.id},
            OperationType: "${data.OperationType}",
            ShipmentType: "${data.ShipmentType}",
            ShowLogo: ${data.ShowLogo},
            ShowPODtext: ${data.ShowPODtext},
            Signature_Required:${data.Signature_Required},
            Consignee_DisplayText: "${data.Consignee_DisplayText}",
            Consignee_Visible: ${data.Consignee_Visible},
            ReleasedTo_DisplayText: "${data.ReleasedTo_DisplayText}",
            ReleasedTo_Visible: ${data.ReleasedTo_Visible},
            DriverName_DisplayText: "${data.DriverName_DisplayText}",
            DriverName_Visible: ${data.DriverName_Visible},
            ${arrayBodyString}
            ${arrayTableString} 
            Footer: "${data.Footer}"
        }) {
            success
            message
        }
    }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
    }).then((res) => res.json());
    console.log(response, 'sagas save config POD')
    const responseAccess = response.data.SaveConfigReportPOD;
    if (responseAccess?.success) {
        Swal.fire('Successful', responseAccess.message, 'success');
    } else {
        Swal.fire('Error', responseAccess?.message || 'An unknown error occurred', 'error');
    }
    return responseAccess.success;
};

function* saveConfigPODSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchSaveConfigPOD, data.payload);
        yield put(saveConfigPODSuccess(response));
    } catch (error) {
        yield put(saveConfigPODFail(error));
    }
}

function* ConfigPODSaga() {
    yield takeEvery(ConfigPODTypes.GET_CONFIG_POD, getConfigPODSaga);
    yield takeEvery(ConfigPODTypes.SAVE_CONFIG_POD, saveConfigPODSaga);
}

export default ConfigPODSaga;
